import { render, staticRenderFns } from "./partAdmin.vue?vue&type=template&id=2c418270&"
import script from "./partAdmin.vue?vue&type=script&lang=js&"
export * from "./partAdmin.vue?vue&type=script&lang=js&"
import style0 from "./partAdmin.vue?vue&type=style&index=0&id=2c418270&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports